import { Fragment, useContext } from "react";

import { useTranslation } from "react-i18next";

import CardItemValue from "components/TableDetails/components/CardItemValue";
import { TitleInfo } from "components/TableDetails/components/TitleInfo";
import { renderAvailableData } from "components/TableDetails/functions";
import TableContext from "context/table/tableContext";

import { CARD_ITEMS, CARDS } from "../../types";
import { DetailsData } from "../types";

const Sim = () => {
    const { detailsData } = useContext(TableContext);

    const { t } = useTranslation();

    const { gsm_number, iccid, imsi }: DetailsData = detailsData;

    const list = [
        { title: CARD_ITEMS.GsmNumber, value: gsm_number, isAvailable: true },
        {
            title: CARD_ITEMS.Iccid,
            value: iccid,
            isAvailable: true
        },
        {
            title: CARD_ITEMS.Imsi,
            value: imsi,
            isAvailable: true
        }
    ];

    return (
        <div>
            <div>
                {t(`Table##${CARDS.Sim}`)}

                <TitleInfo
                    aria-label={t(`Table##${CARDS.Sim}`)}
                    cardName={CARDS.Sim}
                    list={list}
                />
            </div>

            <div>
                {renderAvailableData(list).map(({ title, value }) => {
                    return (
                        <Fragment key={title}>
                            <span>{t(`Table##${title}`)}:</span>
                            <CardItemValue value={value} />
                        </Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export { Sim };
